<ng-container [formGroup]="formGroup">
  <mat-form-field class="login-wrap__text">
    <mat-label>{{ 'pages.restaurantAccount.adVistarMediaApiKey' | translate }}</mat-label>
    <input matInput appFormInputTrim formControlName="apiKey">
    <mat-error *ngIf="formGroup.get('apiKey')?.errors && formGroup.get('apiKey')?.touched">
      {{ 'pages.restaurantAccount.maxLengthValidation' | translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="login-wrap__text">
    <mat-label>{{ 'pages.restaurantAccount.adVistarMediaNetworkId' | translate }}</mat-label>
    <input matInput appFormInputTrim formControlName="networkId">
    <mat-error *ngIf="formGroup.get('networkId')?.errors && formGroup.get('networkId')?.touched">
      {{ 'pages.restaurantAccount.maxLengthValidation' | translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="login-wrap__text">
    <mat-label>{{ 'pages.restaurantAccount.adVistarMediaVenueId' | translate }}</mat-label>
    <input matInput appFormInputTrim formControlName="venueId">
    <mat-error *ngIf="formGroup.get('venueId')?.errors && formGroup.get('venueId')?.touched">
      {{ 'pages.restaurantAccount.maxLengthValidation' | translate }}
    </mat-error>
  </mat-form-field>
</ng-container>
